import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=319afda4&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=319afda4&scoped=true&lang=less&"
import style1 from "./Detail.vue?vue&type=style&index=1&id=319afda4&scoped=true&lang=less&"
import style2 from "./Detail.vue?vue&type=style&index=2&id=319afda4&lang=less&scoped=true&"
import style3 from "./Detail.vue?vue&type=style&index=3&id=319afda4&lang=less&scoped=true&"
import style4 from "./Detail.vue?vue&type=style&index=4&id=319afda4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319afda4",
  null
  
)

export default component.exports